import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';
import { InputUtil } from '../../store';

@Pipe({
  name: 'date'
})
export class DateDirective extends DatePipe implements PipeTransform {

  transform(value: any, args?: string, timezone?: string, locale?: string): any {
    if (typeof value === 'string') {
      value = InputUtil.parseBirthday(value);
    }
    return super.transform(value, args, timezone, locale);
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/pipes/date.directive.ts